module.exports = "/_next/static/videos/footwear-2-30b4c446b4be70ad696294cc1be641e5.webm";